export default __webpack_public_path__ + "static/media/a3.be72d01b.JPG";